import { createSelector } from 'reselect';

export default createSelector(
    state => state.seat_selection.workflow,
    ({ modifierKeys }) => modifierKeys,
);
